import React from "react";
import { Link } from "react-router-dom";

export const splitGenres = (genre) => (genre || "").split(",").map((g) => g.trim()).filter(Boolean);

export function GenrePill({ genre, className = "" }) {
  return splitGenres(genre).map((g) => (
    <Link key={g} to={`/pool?genre=${encodeURIComponent(g)}`} onClick={(e) => e.stopPropagation()}
      data-testid={`genre-pill-${g.toLowerCase().replace(/\s+/g, "-")}`}
      className={`font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded border text-white/60 border-white/10 hover:text-red-400 hover:border-red-600/50 transition-colors ${className}`}>
      {g}
    </Link>
  ));
}
